import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43cfb898"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon" }
const _hoisted_2 = ["xlink:href"]



export default /*#__PURE__*/_defineComponent({
  props: ['name'],
  setup(__props) {

const importAll = (requireContext: any) => requireContext.keys().forEach(requireContext)
importAll(require.context('@/assets/icons', true, /\.svg$/))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("use", {
      "xlink:href": '#' + __props.name
    }, null, 8, _hoisted_2)
  ]))
}
}

})